export default function percentage(total, part) {
  if (total === 0) { // salvo l'universo evitando una divisione per zero
    return 0;
  }
  return 100 * (part - total) / total;
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/util/percentage.js
 **/